import { blogPosts } from "../../utils/blogData";
import BlogCard from "../../components/BlogCard";
import HeroBlog from "../../components/HeroBlog";

const BlogList = () => {
  return (
    <div className=" md:max-w-[90%] mx-auto p-3 md:p-6 space-y-4 mt-20">
      <HeroBlog />
      <div className="pt-10">
        <h1 className="text-4xl font-bold mb-4">Blogs</h1>
        {blogPosts.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default BlogList;
